import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { CalculateOutlined } from '@mui/icons-material';
import { useCostEditor } from '../../../../hooks/useCostEditor';

/**
 * TotalCostEditor - Read-only computed field showing the sum of
 * labor, parts, and vendor costs. Formatted as currency.
 */
export const TotalCostEditor: React.FC = () => {
  const { costRecord } = useCostEditor();

  const totalCost = costRecord?.totalCost ?? 0;

  const formattedTotal = totalCost.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <TextField
      label="Actual Cost"
      value={formattedTotal}
      size="small"
      fullWidth
      InputProps={{
        readOnly: true,
        startAdornment: (
          <InputAdornment position="start">
            <CalculateOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
      sx={{
        '& .MuiInputBase-root': {
          backgroundColor: '#f1f5f9',
        },
        '& .MuiInputBase-input': {
          fontWeight: 600,
          color: '#1e293b',
        },
      }}
    />
  );
};

export default TotalCostEditor;
